import React from 'react'

export default function TracksLis({ className }) {
  return (
    <svg viewBox="0 0 29 23" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M28.818 15.779c-.694 3.637-6.535 7.218-6.535 7.218s-5.801-3.581-6.495-7.218a3.48 3.48 0 01-.001-1.387c.274-1.37 1.419-2.464 2.805-2.684a3.44 3.44 0 013.329 1.341.469.469 0 00.764 0 3.44 3.44 0 013.329-1.341c1.386.22 2.531 1.314 2.805 2.684a3.48 3.48 0 01-.001 1.387zm-8.026-6.756H2.442A1.507 1.507 0 01.931 7.52c0-.83.676-1.504 1.511-1.504h18.35c.834 0 1.511.674 1.511 1.504s-.677 1.503-1.511 1.503zm0-6.014H2.442A1.508 1.508 0 01.931 1.505c0-.83.676-1.504 1.511-1.504h18.35c.834 0 1.511.674 1.511 1.504s-.677 1.504-1.511 1.504zm-18.35 8.895h9.281c.834 0 1.511.674 1.511 1.504s-.677 1.504-1.511 1.504H2.442a1.508 1.508 0 01-1.511-1.504c0-.83.676-1.504 1.511-1.504zm0 6.015h9.281c.834 0 1.511.674 1.511 1.504s-.677 1.503-1.511 1.503H2.442a1.507 1.507 0 01-1.511-1.503c0-.83.676-1.504 1.511-1.504z"
      />
    </svg>
  )
}
